import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/HomeView.vue'
import CoursesList from '@/components/courses/CoursesList.vue'
import SimulatorList from '@/components/courses/SimulatorList.vue'
import Appiontments from '@/components/courses/Appointments.vue'
import UserRegistration from '@/components/UserRegistration.vue'
import PaymentSuccess from '@/components/paypal/PaymentSuccess.vue'
import PaymentCancel from '@/components/paypal/PaymentCancel.vue'
import ReservationFailed from '@/components/paypal/ReservationFailed.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/appointments',
      component: Appiontments,
      children: [
        {
          path: 'Phako',
          name: 'appointments_by_course',
          component: CoursesList
        },
        {
          path: 'Simulator',
          name: 'appointments_of_simulator',
          component: SimulatorList
        }
      ]
    },
    {
      path: '/registration',
      name: 'user_registration',
      // props: (route) => { return { selectedAppointments: route.params.selectedAppointments } },
      component: UserRegistration
    },
    {
      path: '/payment/success',
      name: 'payment_success',
      component: PaymentSuccess
    },
    {
      path: '/payment/cancel',
      name: 'payment_cancel',
      component: PaymentCancel
    },
    {
      path: '/reservation-failed',
      name: 'reservation_failed',
      component: ReservationFailed
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/AboutView.vue')
    },
    {
      path: '/impressum',
      name: 'impressum',
      component: () => import('./views/ImpressumView.vue')
    },
    {
      path: '/datenschutzerklaerung',
      name: 'datenschutzerklaerung',
      component: () => import('./views/DatenschutzView.vue')
    }
  ]
})
